import { render, staticRenderFns } from "./single-work-blink.vue?vue&type=template&id=60388ef8&scoped=true&lang=pug&"
import script from "./single-work-blink.vue?vue&type=script&lang=js&"
export * from "./single-work-blink.vue?vue&type=script&lang=js&"
import style0 from "./single-work-blink.vue?vue&type=style&index=0&id=60388ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60388ef8",
  null
  
)

export default component.exports